//@flow
import React from 'react';
import {makeStyles, Tooltip} from '@material-ui/core';
import type {TooltipProps} from '@material-ui/core';
import {colors} from '../../assets/styles/colors';

const useStyles = makeStyles(theme => ({
  tooltip: {
    backgroundColor: colors.grey700,
    borderRadius: '.5rem',
    textAlign: 'center',
    color: '#F4F4F6',
    fontSize: 12,
    maxWidth: 240,
  },
}));

type Props = {
  children: React$Node,
} & TooltipProps;

export default function TiendadaTooltip(props: Props) {
  const {children, ...tooltipProps} = props;

  const classes = useStyles();
  return (
    <Tooltip
      enterTouchDelay={0}
      classes={{tooltip: classes.tooltip}}
      {...tooltipProps}
    >
      {children}
    </Tooltip>
  );
}
